import React, { useState, useEffect } from 'react';
import { ShieldCheckIcon, XMarkIcon } from '@heroicons/react/24/outline';

const ForumRules = () => {
  const [isDismissed, setIsDismissed] = useState(false);

  // Check localStorage on mount
  useEffect(() => {
    const dismissed = localStorage.getItem('forumRulesDismissed');
    if (dismissed === 'true') {
      setIsDismissed(true);
    }
  }, []);

  const handleDismiss = () => {
    setIsDismissed(true);
    localStorage.setItem('forumRulesDismissed', 'true');
  };

  if (isDismissed) {
    return null;
  }

  return (
    <div className="relative overflow-hidden rounded-lg bg-gradient-to-r from-purple-50 to-amber-50 dark:from-purple-900/20 dark:to-amber-900/20 border border-purple-200 dark:border-purple-800 shadow-sm">
      <div className="px-4 py-3 sm:px-6 sm:py-4">
        <div className="flex items-start">
          {/* Icon */}
          <div className="flex-shrink-0">
            <ShieldCheckIcon 
              className="h-6 w-6 sm:h-7 sm:w-7 text-purple-600 dark:text-purple-400" 
              aria-hidden="true" 
            />
          </div>

          {/* Content */}
          <div className="ml-3 flex-1">
            <h3 className="text-sm sm:text-base font-semibold text-gray-900 dark:text-white mb-1">
              Community Guidelines
            </h3>
            <div className="text-sm sm:text-base text-gray-700 dark:text-gray-300">
              <p className="leading-relaxed">
                <span className="font-medium text-purple-700 dark:text-purple-300">No promotional posts, selling, or spamming users.</span>
                {' '}If reported, your account will be subject to review and deactivation.
              </p>
            </div>
          </div>

          {/* Dismiss Button */}
          <div className="ml-3 flex-shrink-0">
            <button
              type="button"
              onClick={handleDismiss}
              className="inline-flex rounded-md p-1.5 text-purple-600 hover:bg-purple-100 dark:text-purple-400 dark:hover:bg-purple-900/30 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2 dark:focus:ring-offset-gray-900 transition-colors duration-200"
              aria-label="Dismiss community guidelines"
            >
              <XMarkIcon className="h-5 w-5" aria-hidden="true" />
            </button>
          </div>
        </div>
      </div>

      {/* Decorative gradient border on the left */}
      <div className="absolute left-0 top-0 bottom-0 w-1 bg-gradient-to-b from-purple-500 to-amber-500"></div>
    </div>
  );
};

export default ForumRules;
